import { BoxedBatteryIcon } from '@jouzen/ecom-components/icons/BoxedBatteryIcon';
import { BoxedBatteryIcon2024 } from '@jouzen/ecom-components/icons/BoxedBatteryIcon2024';
import { BoxedBedIcon } from '@jouzen/ecom-components/icons/BoxedBedIcon';
import { BoxedDiamondIcon } from '@jouzen/ecom-components/icons/BoxedDiamondIcon';
import { BoxedMeditationIcon } from '@jouzen/ecom-components/icons/BoxedMeditationIcon';
import { BoxedReadinessOutlineIcon } from '@jouzen/ecom-components/icons/BoxedReadinessOutlineIcon';
import { BoxedSensingIcon } from '@jouzen/ecom-components/icons/BoxedSensingIcon';
import { BoxedSensorsIcon } from '@jouzen/ecom-components/icons/BoxedSensorsIcon';
import { BoxedTitaniumIcon } from '@jouzen/ecom-components/icons/BoxedTitaniumIcon';
import { BoxedWaterDropIcon } from '@jouzen/ecom-components/icons/BoxedWaterDropIcon';
import { BoxedWaterResistIcon } from '@jouzen/ecom-components/icons/BoxedWaterResistIcon';
import type { SVGIconComponent } from 'types/svgr';

export type SlideshowItemIconDataType = Readonly<
  Record<string, SVGIconComponent>
>;

export const SlideshowItemIconData: SlideshowItemIconDataType = {
  sensors_boxed: BoxedSensorsIcon,
  battery_boxed: BoxedBatteryIcon,
  titanium_boxed: BoxedTitaniumIcon,
  water_resist_boxed: BoxedWaterResistIcon,
  battery_boxed_2024: BoxedBatteryIcon2024,
  diamond_boxed: BoxedDiamondIcon,
  sensing_boxed: BoxedSensingIcon,
  water_drop_boxed: BoxedWaterDropIcon,
  meditation_boxed: BoxedMeditationIcon,
  readiness_outline_boxed: BoxedReadinessOutlineIcon,
  bed_boxed: BoxedBedIcon,
};
